import styled from "styled-components";

export const UsageContainer = styled.div`
  padding: 30px;
  background-color: #fafcff;
  overflow: auto;
  max-height: calc(100vh - 116px);
`;

export const ChartRow = styled.div`
  /* display: flex; */
  /* align-items: stretch; */
  display: grid;
  grid-template-columns: 0.5fr 0.5fr;
  gap: 25px;
  padding: 10px;
  margin-bottom: 30px;
  > div {
    /* width: 50%; */
    background-color: #fff;
    box-shadow: 2px 4px 5px 2px rgba(0, 0, 0, 0.02);
    padding: 15px;
    min-height: 400px;
    :nth-child(2) {
      padding-bottom: 88px !important;
    }
    .heading {
      padding-bottom: 15px;
    }
    .action-btn {
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      button,
      a {
        background: #ffffff;
        border: 1px solid #636f7c;
        border-radius: 30px;
        height: 30px;
        font-size: 13px;
        line-height: 150.5%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
      }
      a {
        text-decoration: none;
        color: #000;
      }
    }
    /* :first-child {
      width: 50%;
    } */
  }
`;

export const Wrapper = styled.div``;

export const SortingHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 28px;
  background: var(--filter-bar-bg);
  flex-wrap: wrap;
  gap: 10px 0;

  .label-wrapper {
    display: flex;
    align-items: center;
    border-right: 1px solid #cdcfd0;
    padding: 0 10px;
    gap: 7px;
    .hr {
      color: #fff;
      font-size: 14px;
      line-height: 16px;
    }
    .MuiInputBase-root {
    max-width: 150px;
    background: #ffffff;
    border-radius: 6px;
}
.MuiInputBase-input {
    font-size: 13px;
    line-height: 150%;
    padding: 6px 10px;
    min-height: auto;
    border: none;
}
    input {
      background: var(--input-background);
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      min-height: 30px;
      padding: 0 10px;
    }
    label {
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
      color: var(--theme-text);
    }
    .MuiSelect-select {
      padding: 3.5px 14px;
      background: var(--input-background);
      font-size: 13px;
    }
  }
  .btn-header-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 10px;
    flex-wrap: wrap;
    border-right: 1px solid #cdcfd0;
    button {
      font-size: 13px;
      border-color: var(--filter-bar-btn-border);
      color: var(--theme-text);
    }
    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    .MuiInputBase-root {
      background: var(--input-background);
      position: relative;
    }
    .arrow-icon {
      position: absolute;
      right: 9px;
    }
    .MuiNativeSelect-select {
      padding: 3.5px 14px;
      font-size: 13px;
      height: auto;
    }
  }
`;
